import { lazy } from "react";

export const AppointmentAsync = lazy(() => import("./Appointment"));
